module.exports = __webpack_public_path__ + "img/purple-hair-doc.2ccb93ba.png";